/**
 * Safely decode a possibly-base64-encoded message body.
 *
 * Some send paths persist the WhatsApp/SMS/push body base64-encoded; others store plain
 * text. This decodes ONLY when the string clearly looks like base64 and yields valid UTF-8,
 * otherwise it returns the input unchanged. It is therefore idempotent on already-plain text
 * (safe to apply even if the backend already decoded).
 */
export function decodeMessageBody(raw?: string | null): string {
  if (!raw) return '';
  const s = raw.trim();
  // Plain messages contain spaces / * / newlines / emoji → fail the base64 charset check and
  // are returned as-is. Require a reasonable length so short ASCII words aren't mis-decoded.
  if (s.length < 16 || s.length % 4 !== 0 || !/^[A-Za-z0-9+/]+={0,2}$/.test(s)) return raw;
  try {
    const bin = atob(s);
    const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
    // fatal:true throws on invalid UTF-8 → coincidental base64 falls back to raw.
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
  } catch {
    return raw;
  }
}
